import $ from 'jquery';

export default class TestimonialsWidget {
    constructor() {
        this.init();
    }

    init() {
        this.$widget = $('.testimonials-widget-component');
        this.$slides = this.$widget.find('.testimonial');
    }

    abjustHeight() {
        let max = 0;
        this.$slides.each((i, e) => {
            console.log(e.style );
            if (e.style.height > max)
                max = e.style.height;
        });

        console.log('max:' + max);
        this.$slides.each((i, e) => {
            e.style.height = max;
        });
    }
}